import React, { useState, useRef, useCallback, useEffect } from "react";
import { ListGroup } from "react-bootstrap";

const CustomizeList = ({
  value,
  onChange,
  placeholder = "Enter value or select NA",
  icon = null,
  mandatory = false,
}) => {
  const [inputValue, setInputValue] = useState(value || "");
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);
  // Handle input blur to close dropdown
  const handleInputBlur = useCallback(() => {
    setShowDropdown(false);
  }, []);

  // Prevent input blur when clicking on dropdown
  const handleDropdownMouseDown = useCallback((event) => {
    event.preventDefault();
  }, []);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
    onChange?.(value);

    // Close dropdown when typing anything except empty input
    // Still allow explicit NA selection
    if (value === "") {
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handleInputFocus = () => {
    // Only show dropdown when empty
    if (inputValue === "") {
      setShowDropdown(true);
    }
  };

  const handleDropdownSelect = () => {
    setInputValue("NA");
    onChange?.("NA");
    setShowDropdown(false);
  };

  return (
    <div ref={wrapperRef} style={{ position: "relative" }}>
      <div class="input-group">
        {!!icon && <span class="input-group-text">{icon}</span>}
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onClick={handleInputFocus}
          onBlur={handleInputBlur}
          placeholder={placeholder}
          className={
            mandatory === true ? "form-control no-border-rgt" : "form-control"
          }
        />
        {mandatory === true && (
          <span className="input-group-text text-danger fw-bold fs-5 px-1">
            *
          </span>
        )}
      </div>

      {showDropdown && (
        <div ref={dropdownRef} onMouseDown={handleDropdownMouseDown}>
          <ListGroup className="modal-links mx-1 mt-1">
            <ListGroup.Item
              action
              variant="light"
              className="p-1"
              onClick={handleDropdownSelect}
            >
              NA
            </ListGroup.Item>
          </ListGroup>
        </div>
      )}
    </div>
  );
};

export default CustomizeList;
